<template>
  <i-dx-popup :popupVisible="popupVisible" :title="'고객사 선택'" @popupCloseButtonClick="closeBtn(false)" height="650px" width="35vw">
    <template v-slot:grid>
      <v-tabs active-class="active_tab" class="mt-3" v-model="tab">
        <v-tab class="px-2" v-for="item in tabs" :key="item.tabId" @click="clickTab(item.tabId)">{{ item.title }}</v-tab>
        <v-tabs-items v-model="tab" :touchless="true">
          <v-tab-item>
            <v-card width="100%" class="v-application" style="padding: 10px; display: block;">
              <i-search-panel :searchPanel="searchPanel"></i-search-panel>
              <DxDataGrid
                id="mainGrid"
                width="100%"
                height="400px"
                ref="mainGridRef"
                :data-source="gridMain"
                :remote-operations="false"
                :hover-state-enabled="true"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :row-alternation-enabled="true"
                :column-auto-width="true"
                :show-borders="true"
                :show-row-lines="true"
                :selection="{ mode: 'single' }"
                key-expr="rgstNo"
                :focused-row-enabled="true"
                @focused-row-changed="onFocusedRowChanged"
              >
                <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                <DxSelection :select-all-mode="'allPages'" show-check-boxes-mode="always" mode="single" />
                <DxColumn width="250px" data-field="clntNm" data-type="string" alignment="center" caption="고객사명" :allow-editing="false" />
                <DxColumn width="200px" data-field="rgstNo" data-type="string" alignment="left" caption="사업자 등록번호" :allow-editing="false" />
                <DxColumn width="80px" data-field="rpstNm" data-type="string" alignment="center" caption="대표자" :allow-editing="false" />
              </DxDataGrid>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card width="100%" class="v-application" style="padding: 10px; display: block;">
              <i-search-panel :searchPanel="searchPanel"></i-search-panel>
              <DxDataGrid
                id="unissuedGrid"
                width="100%"
                height="400px"
                ref="unissuedGridRef"
                :data-source="unissuedGridMain"
                :remote-operations="false"
                :hover-state-enabled="true"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :row-alternation-enabled="true"
                :column-auto-width="true"
                :show-borders="true"
                :show-row-lines="true"
                :selection="{ mode: 'single' }"
                key-expr="rgstNo"
                :focused-row-enabled="true"
                @focused-row-changed="onFocusedRowChanged"
              >
                <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                <DxSelection :select-all-mode="'allPages'" show-check-boxes-mode="always" mode="single" />
                <DxColumn width="250px" data-field="clntNm" data-type="string" alignment="center" caption="고객사명" :allow-editing="false" />
                <DxColumn width="200px" data-field="rgstNo" data-type="string" alignment="left" caption="사업자 등록번호" :allow-editing="false" />
                <DxColumn width="80px" data-field="rpstNm" data-type="string" alignment="center" caption="대표자" :allow-editing="false" />
              </DxDataGrid>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </template>
  </i-dx-popup>
</template>
<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import iSearchPanel from '@/components/common/iSearchPanel.vue'

// API
import { getClientManage } from '@/api/adminManagement/clientManage'
import { getClientManageDetail } from '@/api/adminManagement/clientManage'
import {
  getUnissuedClient // 미발행 업체 조회
} from '@/payment/api/taxInvoice.js'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    IDxPopup,
    iSearchPanel
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      tabs: [
        { tabId: 'all', title: '전체' },
        { tabId: 'todo', title: '미발행' }
      ],
      tab: '',
      selectedTab: 'all',
      gridMain: [],
      unissuedGridMain: [],
      searchPanel: true
    }
  },
  watch: {},
  created() {},
  activated() {},
  beforeMount() {},
  mounted() {
    this.searchClient(this.tabs[0].tabId)
  },
  methods: {
    // 거래처 관리 팝업 호출 (고객사 조회)
    searchClient(tab) {
      if (tab === 'all') {
        let params = {
          useYn: 'Y'
        }
        getClientManage(params).then(res => {
          this.gridMain = res.clientInfoData
        })
      } else if (tab === 'todo') {
        let params = {
          useYn: 'Y'
        }
        getUnissuedClient(params).then(res => {
          this.unissuedGridMain = res.list
        })
      }
    },

    ///////////////////////////////////////
    /*            Grid Event             */
    ///////////////////////////////////////
    onFocusedRowChanged(e) {
      console.log('@@ e', e)
      if (e.rowIndex < 0) return
      if (e.row.rowType === 'data') {
        let emitData = e.row.data
        // 추후 공통코드 compId 삭제될 예정 그 동안 clntId 넣어줌
        this.vToastifyPrompt(
          this.$t(`[${emitData.clntNm}]고객을 선택 하시겠습니까?`),
          'info',
          current => {
            getClientManageDetail({ clntId: emitData.clntId })
              .then(res => {
                console.log('@@res', res)
                emitData.detailNm = res.detailNm
                emitData.email = res.email
              })
              .finally(() => {
                this.$emit('popupClose', emitData)
              })
          },
          null,
          true
        )
      }
    },
    foundGridComponent() {
      // 그리드 찾기
      console.log('@@ this.$children', this.$children)
      let childrenCompoent = this.$children[0].$children
      // let childrenCompoent2 = this.$children[0].$children

      let gridComponent = null
      gridComponent = childrenCompoent[0].$children.find(element => {
        // console.log('instance.NAME', element.instance ? element.instance.NAME : '')
        return element.instance ? element.instance.NAME === 'dxDataGrid' : false
      })

      // console.log('dododo', childrenCompoent[3].instance)
      // console.log('gridComponent', gridComponent, !!gridComponent)
      this.searchPanel = !!gridComponent
    },

    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    // 팝업 닫기
    closeBtn() {
      this.$emit('popupClose', {})
    },
    async clickTab(id) {
      if (this.selectedTab === id) return
      this.selectedTab = id
      this.searchClient(id)
    }
  }
}
</script>

<style lang="scss">
.right-input >>> input {
  text-align: right;
}
</style>
